$(document).ready(function() {
  $(".trix-file").click(function(e) {
    $(this).attr("target","_blank");
  });
});
